import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import { ServicesFactoryInstance } from "../../../Controls/ServicesFactory";
import { ParametresInstance } from "../../../Controls/Parameters";
import { SocieteReglementsDto } from "../../../../dto/GenApi.iNotPaie.Dto/SocieteReglementsDto";
import { ReglementTypeDto } from "../../../../dto/GenApi.iNotPaie.Dto/ReglementTypeDto";
import { NotificationServiceInstance } from "../../../../shared/services/notification.service";

@Component
export default class ModalReglements extends Vue {
	public isLoading = true;
	public isUpdate = false;
	public reglement: ReglementTypeDto = { Id: 0, LigneAjoutee: false };
	public reglementOrigine: ReglementTypeDto = { Id: 0, LigneAjoutee: false };
	public societe: SocieteReglementsDto = { Id: 0, ReglementType: [] };

	public Init(societe: SocieteReglementsDto, reglement?: any): void {
    	this.isLoading = true;
    	this.societe = societe;

    	if (reglement != undefined) {
    		this.isUpdate = true;
    		this.reglementOrigine = reglement;
    		this.reglement = JSON.parse(JSON.stringify(this.reglementOrigine));
    	} else if (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.Code != undefined) {
    		this.isUpdate = false;
    		this.reglement = { Id: 0, LigneAjoutee: false, IdSociete: ParametresInstance.societeCourante.Id };
    	}
    	this.isLoading = false;
    	this.$forceUpdate();
	}

	public annuler(): void {
    	$("#modalReglements").modal("hide");
    	this.$emit("refresh");
	}

	public update(): void {
    	this.isLoading = true;
    	ServicesFactoryInstance.SocieteService.updateSocieteReglement(this.reglement, data => {
    		if (this.isUpdate) {
    			this.reglementOrigine = data;
    			NotificationServiceInstance.SendSuccess("Le règlement a été modifié avec succès.");
    		} else {
    			NotificationServiceInstance.SendSuccess("Le règlement a été créé avec succès.");
    			this.societe.ReglementType.push(data);
    		}
    		this.isLoading = false;
    		this.annuler();
    	}, () => {
			this.isLoading = false;
		});
	}
}



// WEBPACK FOOTER //
// ./src/components/ficheSociete/reglements/modalReglements/modalReglements.ts